<!-- @format -->

<template>
  <div class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />

    <div class="modal-body" v-else key="content-loading">
      <el-row>
        <transition name="el-fade-in" mode="out-in">
          <el-col :span="24" v-if="sendVoucherLoading == false">
            <el-row :gutter="16">
              <el-col :span="24">
                <div class="registration-question">
                  <div class="sub-title">{{ $t("components.participants.sendVoucher.certificateSelection") }}</div>
                  <el-select v-model="form.certificateSchemeId" style="width:100%;" :clearable="true" @clear="form.certificateSchemeId = null">
                    <el-option v-for="certificate in certificates" :key="certificate.id" :value="certificate.id" :label="certificate.title"></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24" class="text-center" v-if="sendVoucherLoading == 'sending'" key="title">
            <p>{{ $t("components.participants.sendVoucher.sendingCertificateStart") }}</p>
            <p>{{ $t("components.participants.sendVoucher.sendingStartInfo") }}</p>
          </el-col>
          <el-col :span="24" v-if="sendVoucherLoading == 'completed'" class="text-center">
            <p>{{ $t("components.participants.sendVoucher.sendingCertificateEnd") }}</p>
          </el-col>
        </transition>
        <el-col :span="24" class="d-flex align-center justify-content-center">
          <lottie-player autoplay loop mode="normal" src="https://assets3.lottiefiles.com/packages/lf20_mnyzhelm.json" style="width: 150px"> </lottie-player>
        </el-col>
      </el-row>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeMe')">{{ $t("contentManagement.speakers.speakerAddUpdate.close") }}</el-button>
        <!-- <template>
            <el-popconfirm :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
              <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t('contentManagement.speakers.speakerAddUpdate.delete') }}</el-button>
            </el-popconfirm>
          </template> -->
      </div>
      <div class="right-buttons" v-if="sendVoucherLoading == false">
        <el-button type="primary" @click="startVoucherSend" :loading="loading == true">{{ $t("components.participants.sendVoucher.startSending") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {

  props: ["payload"],
  name: "SendCertificate",
  data() {
    return {
      sendVoucherLoading: false,
      loading: false,
      form: JSON.parse(JSON.stringify(this.payload)),
      timeout: null,
			certificates: [],
    };
  },
  computed: {
    voucherList() {
      return this.$store.state.automatedmessages.items;
    }
  },
  async created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      var res = await axios.post("/Certificate/List", { searchTerm: null, skip: 0, take: 1000 });
      this.certificates = res.data.data.items;
      this.loading = false;
    }, 500);
  },
  methods: {
    async startVoucherSend() {
      this.loading = true;
      this.sendVoucherLoading = "sending";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("sendCertificateParticipant", this.form);
        if (!res.data.alert.hasError) {
          this.sendVoucherLoading = "completed";
        } else {
          this.sendVoucherLoading = false;
        }
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.export-display {
  background-color: #03658c;
  padding: 1rem;
  border-radius: 1rem;
  display: flex;
  gap: 10px;
  flex-direction: column;
  .first {
    display: flex;
    gap: 10px;
    .total {
      background-color: white;
      padding: 10px;
      border-radius: 1rem;
      font-weight: bold;
      text-align: center;
      flex-shrink: 0;
    }
    .file-name {
      width: 100%;
      background-color: white;
      padding: 10px;
      border-radius: 1rem;
      font-weight: bold;
      text-align: center;
      position: relative;

      display: flex;
      align-items: center;
      .file {
        width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      i {
        position: absolute;
        right: 1rem;
        top: calc(~"50% - 9px");
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/participants/SendCertificate.vue